import { render } from "./Addtravel.vue?vue&type=template&id=213a1e74&scoped=true"
import script from "./Addtravel.vue?vue&type=script&lang=js"
export * from "./Addtravel.vue?vue&type=script&lang=js"

import "./Addtravel.vue?vue&type=style&index=0&id=213a1e74&lang=scss&scoped=true"
import "./Addtravel.vue?vue&type=style&index=1&id=213a1e74&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213a1e74"]])

export default __exports__